import { BAG_MACROS, FLAVOURS } from "@/data/content";

const Stat = ({ label, value, accent, testid }) => (
  <div>
    <p className="text-[11px] font-bold uppercase tracking-wider text-[#4A4560]">{label}</p>
    <p data-testid={testid} className={`font-display text-3xl leading-none mt-1 ${accent || ""}`}>{value}</p>
  </div>
);

export const BoxProgress = ({ size, mix, total }) => {
  const full = total === size;
  return (
    <div data-testid="builder-progress" className="rounded-[24px] bg-white border border-[#1B1530]/10 p-4">
      <div className="flex items-center justify-between gap-3 mb-2.5">
        <p className="text-sm font-bold">Box capacity: <span data-testid="builder-count">{total} of {size}</span> bags</p>
        <p data-testid="builder-status" className={`text-sm font-bold ${full ? "text-[#1F9D55]" : "text-[#FF5A5F]"}`}>{full ? "Ready to pack" : `${size - total} to go`}</p>
      </div>
      <div className="h-3 rounded-full bg-[#1B1530]/10 overflow-hidden flex">
        {FLAVOURS.map((f) => (mix[f.key] ? <div key={f.key} className="h-full transition-[width] duration-300" style={{ width: `${(mix[f.key] / size) * 100}%`, background: f.color }} /> : null))}
      </div>
      <div className="mt-3.5 grid grid-cols-3 gap-3">
        <Stat label="Total protein" value={`${total * BAG_MACROS.protein}g`} testid="builder-total-protein" />
        <Stat label="Total calories" value={(total * BAG_MACROS.calories).toLocaleString()} testid="builder-total-calories" />
        <Stat label="Less sugar vs candy" value="75%" accent="text-[#1F9D55]" testid="builder-sugar" />
      </div>
    </div>
  );
};
